export default __webpack_public_path__ + "717ec95.png";